import styled from 'styled-components'

export const Title = styled.div`
  font-weight: 600;
  padding: 0 0 10px 1.5em;
  border-bottom: 1px solid #cbcbcb;
`
